import React, { ComponentProps } from 'react'

import type { RemindersEditorReminderAPIEntity } from '@surglogs-app/network'
import { SelectLegacy } from '@surglogs-app/ui'

import { useRemindersSelectOptions } from '../hooks/useRemindersSelectOptions'
import { useTranslation } from '../services'
import type { RemindersEditorReminderValue } from '../types'

interface RemindersEditorListItemSelectProps
  extends ComponentProps<typeof SelectLegacy> {
  selectedReminders: RemindersEditorReminderValue[]
  clinicReminders?: RemindersEditorReminderAPIEntity[]
  allowCreateReminder?: boolean
}

export const RemindersEditorListItemSelect = ({
  selectedReminders,
  clinicReminders,
  allowCreateReminder,
  ...rest
}: RemindersEditorListItemSelectProps) => {
  const { t } = useTranslation()

  const data = useRemindersSelectOptions({
    clinicReminders,
    selectedReminders,
    allowCreateReminder,
  })

  return (
    <SelectLegacy {...{ data, placeholder: t('selectPlaceholder'), ...rest }} />
  )
}
